import { useMutation, useQueryClient } from '@tanstack/react-query';
import { runPipelineQuery } from '../apis';
import queryKeys from '../constants/queryKeys';

// POST /api/pipelines/{id}/run. Deliberately does NOT auto-toast on error — the caller
// (PipelineRunForm) maps 400 ("no build source found") vs 409 ("a run is already in
// progress") to distinct, actionable inline messages (AC-10/AC-11/AC-20's mapping),
// which a generic toast would blur into one message.
const useRunPipeline = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: runPipelineQuery,
    onSuccess: (_result, variables) => {
      // Refresh the run history for this pipeline and the list's lazily-fetched
      // latest-status cells so the newly-triggered run is reflected everywhere.
      queryClient.invalidateQueries({ queryKey: queryKeys.getRuns(variables?.id) });
      queryClient.invalidateQueries({ queryKey: queryKeys.getList() });
      // M3 (code review): a run can PIN the pipeline's default branch (AC-6) — the very first run
      // against a never-pinned pipeline writes `DefaultBranchName`, which flips the config panel's
      // `EffectiveBranchName`/`IsPipelineOwnedDefault`. Without this the panel keeps reporting
      // "Legacy image-group value" immediately after the one event that stops it being true (AC-9).
      queryClient.invalidateQueries({ queryKey: queryKeys.getBuildSource(variables?.id) });
    },
  });
};

export default useRunPipeline;
